import Mumbai from "../../assets/images/blogs/mumbai.jpeg";
import Pune from "../../assets/images/blogs/Pune.jpeg";
import Ahmedabad from "../../assets/images/blogs/Ahmedabad.jpeg";
import Bangalore from "../../assets/images/blogs/bangalore.jpeg";
import Chennai from "../../assets/images/blogs/chennai.jpeg";
import Coimbatore from "../../assets/images/blogs/coimbatore.png";
import Delhi from "../../assets/images/blogs/delhi_agra.jpeg";
import Hyderabad from "../../assets/images/blogs/hyderabad.jpeg";
import Kochi from "../../assets/images/blogs/kochi.jpeg";
import Kolkata from "../../assets/images/blogs/Kolkata.jpeg";
import Noida from "../../assets/images/blogs/Noida.png";
import Trivandrum from "../../assets/images/blogs/Trivandrum.png";

const blogData = [
  {
    id: 1,
    title: "Top Digital Marketing Agency Mumbai for Businesses",
    excerpt:
      "Mumbai is the financial capital of India and one of the most competitive business hubs in the country.",
    image: Mumbai,
    slug: "digital-marketing-agency-mumbai",
  },
  {
    id: 2,
    title: "Digital Marketing Agency Pune | Grow Your Business Online",
    excerpt:
      "Pune has emerged as one of India’s fastest-growing business and technology hubs.",
    image: Pune,
    slug: "digital-marketing-agency-pune",
  },
  {
    id: 3,
    title: "Digital Marketing Companies in Coimbatore | Grow Your Business Online",
    excerpt:
      "Coimbatore is one of Tamil Nadu’s fastest-growing industrial and business hubs.",
    image: Coimbatore,
    slug: "digital-marketing-agency-coimbatore",
  },

  {
    id: 4,
    title: "Digital Marketing Agency in Kochi | Grow Your Business with Online Marketing",
    excerpt:
      "Kochi has rapidly evolved into one of Kerala’s most important commercial and startup hubs.",
    image: Kochi,
    slug: "digital-marketing-agency-kochi",
  },
  {
    id: 5,
    title: "Digital Marketing Agency in Kolkata | Strategic Online Growth for Businesses",
    excerpt:
      "Kolkata is one of India’s oldest and most culturally rich metropolitan cities, with a rapidly growing business ecosystem",
    image: Kolkata,
    slug: "digital-marketing-agency-kolkata",
  },
  {
    id: 6,
    title: "Digital Marketing Company in Trivandrum That Helps Businesses Get Found Online",
    excerpt:
      "If customers in Trivandrum are searching online for services you offer—but your business doesn’t appear on the first page",
    image: Trivandrum,
    slug: "digital-marketing-agency-trivandrum",
  },

  {
    id: 7,
    title: "Digital Marketing Agency in Bangalore That Helps Businesses Scale Faster",
    excerpt:
      "Bangalore is known as India’s startup and technology capital, where businesses move fast and competition is intense.",
    image: Bangalore,
    slug: "digital-marketing-agency-bangalore",
  },
  {
    id: 8,
    title: "Digital Marketing Companies in Hyderabad for Businesses That Want Real Growth",
    excerpt:
      "Hyderabad has transformed into one of India’s strongest business and technology centres.",
    image: Hyderabad,
    slug: "digital-marketing-agency-hyderabad",
  },
  {
    id: 9,
    title: "Digital Marketing agency in Delhi Helping Brands Compete and Convert Online",
    excerpt:
      "Delhi is one of India’s most competitive business markets, bringing together corporate offices, local enterprises, startups, consultants, retailers, and service providers.",
    image: Delhi,
    slug: "digital-marketing-agency-delhi",
  },

  {
    id: 10,
    title: "Digital Marketing Agency in Ahmedabad for Brands That Want Visibility and Growth",
    excerpt:
      "Ahmedabad has evolved into one of India’s most active business cities, combining strong industrial roots with fast-growing startups, service providers, and professional firms.",
    image: Ahmedabad,
    slug: "digital-marketing-agency-ahmedabad",
  },
  {
    id: 11,
    title: "Digital Marketing Agency in Noida Helping Businesses Get More Leads Online",
    excerpt:
      "Noida has grown into one of North India’s most important business and technology corridors.",
    image: Noida,
    slug: "digital-marketing-agency-noida",
  },
  {
    id: 12,
    title: "Digital Marketing Agency in Chennai Driving Consistent Business Growth",
    excerpt:
      "Chennai is one of India’s strongest business ecosystems, with a powerful mix of manufacturing, IT services, healthcare, education, retail, and professional enterprises.",
    image: Chennai,
    slug: "digital-marketing-agency-chennai",
  },
];

export default blogData;
